export const NAME = 'liveLinks';
export const LINKS = 'linksById';
export const PREVIEW_SITES = 'previewSites';
